import { QueryParamsDTO, TransactionFiltersDTO } from "../models/Transaction";
import axiosInstance from "./axiosInstance";

// customer section
const getCustomerTotalTransactions = async () => {
  const response = await axiosInstance.get("payments/total");
  return response.data;
};
const getCustomerSuccessRate = async () => {
  const response = await axiosInstance.get("payments/success-rate");
  return response.data;
};
const getCustomerTotalCollected = async () => {
  const response = await axiosInstance.get("payments/total-amount");
  return response.data;
};

const getAllTransactionsByUser = async (
    customer_id: string,
    filters: TransactionFiltersDTO
) => {
  const response = await axiosInstance.get("/payments/all", {
    params: {
      status: filters.status || undefined,
      startDate: filters.startDate,
      endDate: filters.endDate,
      search: filters.search || undefined,
      page: filters.page || 1,
      limit: filters.limit || 20,
    },
  });
  // Retourne l'objet complet (contenant data, total, etc.)
  return response.data;
};

const getCustomerTopServices = async () => {
  const response = await axiosInstance.get("/payments/top-services");
  return response.data;
};

// admin section
const getAllTransactions = async (filters: TransactionFiltersDTO) => {
  const response = await axiosInstance.get("payments/admin/all", {
    params: {
      status: filters.status,
      startDate: filters.startDate,
      endDate: filters.endDate,
      page: filters.page || 1,
      limit: filters.limit || 10,
    },
  });
  return response.data.data;
};

const getTotalTransactions = async () => {
  const response = await axiosInstance.get("/payments/admin/total");
  return response.data;
};
const getTotalAmount = async () => {
  const response = await axiosInstance.get("/payments/admin/total-amount");
  return response.data;
};
const adminGetSuccessRate = async () => {
  const response = await axiosInstance.get("payments/admin/success-rate");
  return response.data;
};
const getTopCustomers = async () => {
  const response = await axiosInstance.get("payments/admin/top-customers");
  return response.data;
};
const adminTopCustomers = async () => {
  const response = await axiosInstance.get("payments/admin/top-services");
  return response.data;
};

const transactionDetails = async (transactionId: string) => {
  const response = await axiosInstance.get(`payments/detail/${transactionId}`);
  return response.data;
};

const getTransactionLogs = async (filters: QueryParamsDTO) => {
  const response = await axiosInstance.get("/transaction-logs", {
    params: {
      page: filters.page || 1,
      limit: filters.limit || 10,
      search: filters.search,
      sortBy: filters.sortBy,
      type: filters.type,
    },
  });
  return response.data;
};

const getTransactionLogById = async (id: string) => {
  const response = await axiosInstance.get(`/transaction-logs/${id}`);
  return response.data;
};

const transactionDetailsAdmin = async (transactionId: string) => {
  const response = await axiosInstance.get(`payments/admin/${transactionId}/detail`);
  return response.data;
};

const deleteTransactionLogs = async (ids: string[]) => {
  const response = await axiosInstance.delete("/transaction-logs", {
    data: { ids },
  });
  return response.data;
};

export const transactionsService = {
  getCustomerTotalTransactions,
  getCustomerSuccessRate,
  getCustomerTotalCollected,
  getAllTransactions,
  getAllTransactionsByUser,
  getTotalAmount,
  getTotalTransactions,
  adminGetSuccessRate,
  getTopCustomers,
  adminTopCustomers,
  transactionDetails,
  getCustomerTopServices,
  getTransactionLogs,
  deleteTransactionLogs,
  getTransactionLogById,
  transactionDetailsAdmin
};